module.exports = __webpack_public_path__ + "img/5.285125a8.png";